// MySubmissionsList adapted for Household Items: single moveInDate display.
import React from 'react';
import * as Icon from 'react-bootstrap-icons';

const MySubmissionsList = ({ periods, openEditModal, handleDelete }) => {
  if (!Array.isArray(periods) || periods.length === 0) return null;
  const filtered = periods.filter(p => p && p.id && (p.moveInDate || p.projectName || p.projectAssignment));
  if (filtered.length === 0) return null;
  const formatDisplayDate = (d) => {
    if (!d) return '';
    const str = String(d).replace(/"+$/,'');
    const match = str.match(/^(\d{4})-(\d{2})-(\d{2})/);
    if (!match) { const ts = str.match(/^(\d{4})-(\d{2})-(\d{2})/); if (ts) return `${ts[2]}/${ts[3]}/${ts[1]}`; return ''; }
    const [, y, m, day] = match; return `${m}/${day}/${y}`;
  };
  return (
    <div className="mt-4" style={{ paddingLeft: '2rem' }}>
      <div style={{ width: '50%' }}>
        <h5 style={{ fontSize: '1.2rem', marginBottom: 4 }}>My Allowance Requests</h5>
        <div style={{ borderTop: '2px solid #bbb', width: '100%', marginBottom: 12 }} />
      </div>
      <div className="stay-benefit-cards-vertical" style={{ display: 'flex', flexDirection: 'column', width: '50%' }}>
        {filtered.map((p, idx) => {
          const projectName = p.projectName || p.projectAssignment || '';
          const projectNumber = p.projectNumber || '';
          const projectDisplay = `${projectName}${projectNumber ? ` (${projectNumber})` : ''}`.trim();
          // No total days for single date.
          const totalDays = '';
          let status = (p.status || p.approvalStatus || '').toLowerCase();
          let statusLabel = 'Awaiting Approval', statusColor = '#e6b800';
          if (status === 'approved') { statusLabel = 'Approved'; statusColor = '#28a745'; }
          else if (status === 'rejected') { statusLabel = 'Rejected'; statusColor = '#dc3545'; }
          const isApproved = status === 'approved';
          const bgColor = idx % 2 === 0 ? '#f8f9fa' : '#e9ecef';
          const daysLabel = totalDays ? `${totalDays} ${totalDays === 1 ? 'day' : 'days'}` : '';
          return (
            <div key={p.id} className="stay-benefit-card" style={{ width: '100%', border: '1px solid #ddd', borderBottom: idx === filtered.length - 1 ? '1px solid #ddd' : 'none', borderRadius: 0, padding: 16, background: bgColor, margin: 0, boxShadow: 'none' }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
                <div style={{ flex: 1 }}>
                  <div style={{ fontWeight: 600, fontSize: 16, marginBottom: 4 }}>{(p.firstName || '') + ' ' + (p.lastName || '')}</div>
                  <div style={{ fontSize: 15, color: '#333', marginBottom: 4 }}>{projectDisplay || 'Project'}</div>
                  <div style={{ fontWeight: 400, fontSize: 15, color: '#000', marginBottom: 8 }}>{formatDisplayDate(p.moveInDate)}</div>
                  <div style={{ fontWeight: 500, fontSize: 14, color: statusColor, background: '#fff', borderRadius: 4, padding: '2px 8px', display: 'inline-block', border: `1px solid ${statusColor}` }}>{statusLabel}</div>
                </div>
                {!isApproved && (
                  <div style={{ display: 'flex', gap: 8, alignItems: 'center', justifyContent: 'flex-end' }}>
                    <button type="button" title="Edit" style={{ background: 'none', border: 'none', padding: 0, cursor: 'pointer' }} onClick={() => openEditModal(p)}>
                      <Icon.PencilFill style={{ color: '#da291c', fontSize: 15 }} />
                    </button>
                    <button type="button" title="Delete" style={{ background: 'none', border: 'none', padding: 0, cursor: 'pointer' }} onClick={() => handleDelete(p)}>
                      <Icon.TrashFill style={{ color: '#da291c', fontSize: 15 }} />
                    </button>
                  </div>
                )}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default MySubmissionsList;
